var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{class:_vm.imagenclase,attrs:{"dark":"","position":"center","src":_vm.imagen,"height":_vm.height,"width":_vm.width}},[_c('div',{staticClass:"text-center pt-3"},[_c('strong',[_vm._v(_vm._s(_vm.num_serie))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }